import { AuthState } from '@okta/okta-auth-js'
import { RoleNames } from 'shared/models/Enum'

export const hasRole = (authState: AuthState, role: RoleNames) => {
  return authState.accessToken.claims[
    `lbo-backoffice-administration-frontend-is${role.toLowerCase()}-${getEnv()}`
  ] as boolean
}

export const getRoles = (authState: AuthState) => {
  return Object.values(RoleNames).filter(role => hasRole(authState, role))
}

const getEnv = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'development':
      return 'dev'
    case 'sandbox':
      return 'dev'
    case 'staging':
      return 'acc'
    case 'production':
      return 'prd'
    default:
      return 'dev'
  }
}
